module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/core-js@2.6.12/~/core-js/library/modules/_library.js
// module id = 48
// module chunks = 1 2 3 4